// API Configuration
export const API_BASE_URL = process.env.REACT_APP_API_URL;

// Cognito Configuration
export const COGNITO_USER_POOL_ID = process.env.REACT_APP_COGNITO_USER_POOL_ID;
export const COGNITO_CLIENT_ID = process.env.REACT_APP_COGNITO_CLIENT_ID;
export const COGNITO_REGION = process.env.REACT_APP_COGNITO_REGION;
export const COGNITO_DOMAIN = process.env.REACT_APP_COGNITO_DOMAIN;
export const FRONTEND_URL = process.env.REACT_APP_FRONTEND_URL || window.location.origin;

// Cognito Hosted UI URL
export const getCognitoHostedUIUrl = (state: string): string => {
  const redirectUri = encodeURIComponent(`${FRONTEND_URL}/auth/callback`);
  const scope = encodeURIComponent('openid email');

  // Try using /login endpoint first, fallback to /oauth2/authorize
  return `https://${COGNITO_DOMAIN}/login?` +
    `client_id=${COGNITO_CLIENT_ID}&` +
    `response_type=code&` +
    `scope=${scope}&` +
    `redirect_uri=${redirectUri}&` +
    `state=${state}`;
};

